// extracted by mini-css-extract-plugin
module.exports = {"inactive":"styles_inactive__1LTLP"};